/* eslint react/prop-types: 0 */
import React from 'react';

import Abbr from '../../shared/Abbr';
import CourseCell from './components/CourseCell';
import ResultLink from '../../shared/links/ResultLink';
import { HorseLink } from '../../shared/links/ProfileLink';
import { formatDate, sortByDate } from '../../utils/date';
import { placesSort, zeroToDash } from '../../utils/number';

const columns = [
    {
        key: 'raceDatetime',
        header: 'date',
        cell: props => (
            <ResultLink {...props}>
                {formatDate(props.raceDatetime, 'DDMMMYY')}
            </ResultLink>
        ),
        sortFn: sortByDate('raceDatetime'),
    },
    {
        key: 'horseName',
        header: 'horse',
        cell: ({ horseName, horseUid, countryCode }) => (
            <span>
                <HorseLink horseStyleName={horseName} horseUid={horseUid} />
                <span className="hp-progeny-results__country"> ({countryCode})</span>
            </span>
        ),
        sortFn: 'alphabetic',
    },
    {
        key: 'raceOutcomePosition',
        header: () => <Abbr title="position" breakpoint="fromMedium">pos.</Abbr>,
        cell: ({ raceOutcomePosition, noOfRunners, raceOutcomeCode }) => (
            <span>
                <strong>{raceOutcomePosition || raceOutcomeCode}</strong>/{noOfRunners}
            </span>
        ),
        sortFn: placesSort('raceOutcomePosition'),
    },
    {
        key: 'courseName',
        header: () => (
            <Abbr title="course / conditions / prize">crs.</Abbr>
        ),
        cell: CourseCell,
    },
    {
        key: 'officialRatingRanOff',
        header: 'or',
        cell: zeroToDash('officialRatingRanOff'),
    },
    {
        key: 'rpTopspeed',
        header: 'ts',
    },
    {
        key: 'rpPostmark',
        header: 'rpr',
        cell: zeroToDash('rpPostmark'),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/progenyResults/columns.jsx